
import { getRequestLogs } from '@/core/services/admin-service'
import { LogRow } from '@/types/api/admin/log-row'
import { defineComponent, reactive, toRefs } from 'vue'
import JsonEditorVue from 'json-editor-vue'
import 'vanilla-jsoneditor/themes/jse-theme-dark.css'

export default defineComponent({
  components: { JsonEditorVue },
  setup() {
    const state = reactive({
      apiResponse: null as null | LogRow[][],
      requestId: undefined,
      fromDate: new Date().toISOString().split('T')[0],
      expandedRows: new Set()
    })

    async function getLogs() {
      state.apiResponse = await getRequestLogs(state.requestId, state.fromDate)
      state.expandedRows.clear()
    }

    function toggleExpand(row: LogRow) {
      const rowId = row.loggedOnDate.toString()
      if (state.expandedRows.has(rowId)) {
        state.expandedRows.delete(rowId)
      } else {
        state.expandedRows.add(rowId)
      }
    }

    function isExpanded(row: LogRow) {
      return state.expandedRows.has(row.loggedOnDate.toString())
    }

    function formatDate(dateStr: string) {
      const date = new Date(dateStr)
      return new Intl.DateTimeFormat(
        'en-GB',
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      ).format(date)
    }

    function formatTime(dateStr: string) {
      const date = new Date(dateStr)
      return date.toLocaleTimeString(
        'en-GB',
        {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      )
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function getDataSummary(data: any) {
      if(data)
        return '{...}'
      return 'No data'
    }

    return {
      getLogs,
      toggleExpand,
      isExpanded,
      formatDate,
      formatTime,
      getDataSummary,
      ...toRefs(state)
    }
  }
})
